import { toggleSliderOverlay } from '../functions.js';

document.addEventListener('DOMContentLoaded', () => {
    const $triggerButtons = document.querySelectorAll('.slider-overlay-trigger');
    const $sliderOverlayElement = document.getElementById('slider-overlay');

    if ($triggerButtons && $sliderOverlayElement) {
        Array.from($triggerButtons).forEach(($el) => {
            $el.addEventListener('click', toggleSliderOverlay);
        });
    }
});
